import type { StandardContent } from '@innovamat/ga-features';
import type { ContentBlockTag, StandardTag } from '../types/smart-guide';
import { Stage } from '../types/Stage';
import {
  getStandardBlocks,
  getStandardTags,
  hasContentBlocks,
} from '../utils/standards';

type Props = {
  data: any;
  stage: Stage;
  standardContent?: StandardContent[];
  isCaliforniaStandard?: boolean;
  isBubbleTreeStandard?: boolean;
};

export function mapNewStandardContent({
  data,
  stage,
  standardContent,
  isCaliforniaStandard,
  isBubbleTreeStandard,
}: Props): ContentBlockTag[] | StandardTag[] {
  // create standards from BBDD | can be "standard" or "content block"

  if (standardContent) {
    const hasContentBlocksToDisplay = hasContentBlocks(standardContent);
    if (hasContentBlocksToDisplay) {
      const blocks = getStandardBlocks(standardContent);

      if (blocks.length > 0) {
        return blocks;
      }
    }
    const standards = getStandardTags(standardContent);

    if (standards.length > 0) {
      return standards;
    }
  }

  // return the old way, add here de logic for the different regions, and remove login from the main component

  if (data.bloques_de_contenido_resaltado && isBubbleTreeStandard) {
    return Object.entries(data.bloques_de_contenido_resaltado).map(
      ([key, value]) => {
        const isSecondaryNumAndOps =
          stage === Stage.Secondary && key === 'numbers_and_operations';

        return {
          textKey: isSecondaryNumAndOps
            ? `digitalguides.blocks.${key}.se`
            : `digitalguides.blocks.${key}`,
          isEnabled: value as boolean,
          isFromPrepr: true,
        } as ContentBlockTag;
      }
    );
  }

  if (data.us_standards && isCaliforniaStandard) {
    return data.us_standards?.map((standard: any) => ({
      text: standard.body,
      tooltipKey: undefined,
      isFromPrepr: true,
    })) satisfies StandardTag[];
  }

  return [];
}
